// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../services/spa-claims-build-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getSpaClaims} from '../../shared/repositories';
import {getUser} from '../../../shared/services/get-user';
import {openFile} from '../../../shared/services/open-file';

export const readSpaClaims = (selectedAccounts, selectedSpaLevels) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(selectedAccounts, selectedSpaLevels);

        try {

            const spaClaims = await getSpaClaims(payload);

            dispatch({
                data: spaClaims,
                type: actions.UPDATE_TCSM_SPA_CLAIMS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const exportSpaClaims = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const {tcsmSettings, wipFacets} = getState().tcsm.wip;

        const payload = buildPayload(wipFacets.dealers, tcsmSettings.selectedSpaLevels, 'EXCEL', getUser().getLocale(), 'SpecialAllowanceClaims');

        try {

            const response = await getSpaClaims(payload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-spa-claims.js